import { reactive } from 'vue';
import spiderman from '@/spiderman/index';
import api from '@/api/index';

const member = reactive({
  info: {},
  jwt: '',
  initialize,
});

async function getInfo({ lineToken, clinic }) {
  const { member: memberInfo, jwt } = await api.auth.verify(
    { lineToken, clinic },
  );

  return {
    info: memberInfo, jwt,
  };
}

async function initialize({ liffId, clinic }) {
  if (process.env.NODE_ENV === 'production') {
    await spiderman.liff.init({ liffId });

    if (spiderman.liff.isLoggedIn()) {
      ({ info: member.info, jwt: member.jwt } = await getInfo(
        {
          lineToken: spiderman.liff.getIDToken(),
          clinic,
        },
      ));
    } else {
      spiderman.liff.login();
    }
    return;
  }

  ({ info: member.info, jwt: member.jwt } = await getInfo(
    { lineToken: 'develop', clinic },
  ));
}

export default member;
